(function(window, undefined) {

    'use strict';


    /**
     * sapo videos analytic endpoits for KPI reporting. relies on cors.
     */


    var cors = SAPO.Utility.cors;


    SAPO.namespace('Project.Video');

    /**
     * @function sapoVideosAnalytics
     * @param {Object}   params
     * @... {String}  queryDomain
     * @... {Boolean} autoplay
     * @... {Boolean} isInterno
     * @... {Number}  duration
     * @... {String}  author
     * @... {String}  domain
     * @... {String}  hash
     * @... {String}  teck
     * @param {Function} cb
     */
    SAPO.Project.Video.sapoVideosAnalytics = function(p, cb) {
        var uri = [
            p.protocol,
            '//',
            p.host
            ,'/analytics.html?action=getevents'
            ,'&autostart=',  (p.autoplay ? 'true' : 'false')
            ,'&duration=',   (isFinite(p.duration) ? p.duration : 0)
            ,'&playertype=', (p.isInterno ? 'interno' : 'externo')
            ,'&playerteck=',  p.teck
            ,'&username=',    p.author
            ,'&domain=',      encodeURIComponent( p.pageURI )
            ,'&video=',       p.hash
            ,'&videotype=video'
        ].join('');

        var onOk  = function(err, o) { cb(null, o); };
        var onErr = function(err) { cb(err || 'error'); };

        cors(uri, onOk, onErr, 5);
    };

})(window);
